import React from 'react'
import PropTypes from 'prop-types'
import FilterListItem from './FilterListItem'
import './FilterList.scss'
import FadeInFullscreen from '../FadeInFullscreen'
import { Transition } from 'react-transition-group'

// FilterOptions is an array of objects with the following key/values
/* {
  label: String,
  content: Node
} */

const FULLSCREEN_TRANSITION_DURATION = 200

class FilterList extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      activeItems: []
    }

    this.itemIsActive = this.itemIsActive.bind(this)
    this.deactivateItem = this.deactivateItem.bind(this)
    this.activateItem = this.activateItem.bind(this)
    this.toggleItem = this.toggleItem.bind(this)
    this.startFullScreenAnimation = this.startFullScreenAnimation.bind(this)
    this.markThatUserHasChangedFilters = this.markThatUserHasChangedFilters.bind(
      this
    )
  }

  componentDidUpdate (prevProps) {
    if (this.props.isOpen !== prevProps.isOpen) {
      if (this.props.isOpen) {
        // Reset everytime filter list is just opened
        this.setState({ userHasChangedFilters: false })
      } else {
        this.setState({ activeItems: [] })
      }
    }
  }

  markThatUserHasChangedFilters () {
    this.setState({ userHasChangedFilters: true })
  }

  itemIsActive (idx) {
    return this.state.activeItems.includes(idx)
  }

  deactivateItem (idx) {
    const activeItems = this.state.activeItems.filter(item => item !== idx)
    this.setState({ activeItems })
  }

  activateItem (idx) {
    let activeItems = this.state.activeItems
    activeItems.push(idx)
    this.setState({ activeItems })
  }

  toggleItem (idx) {
    if (this.itemIsActive(idx)) {
      this.deactivateItem(idx)
    } else {
      this.activateItem(idx)
    }
  }

  startFullScreenAnimation (option) {
    this.setState({
      fullscreenContentToShow: option,
      shouldDisplayFullscreenFilters: true
    })
  }

  render () {
    let filterListContent
    let fullscreenDisplay

    if (!this.state.shouldDisplayFullscreenFilters) {
      let resetButton
      if (this.props.onReset) {
        resetButton = (
          <div
            className='FilterList__reset'
            onClick={() => {
              this.markThatUserHasChangedFilters()
              this.props.onReset()
            }}
          >
            Reset Filters
          </div>
        )
      }

      filterListContent = (
        <Transition
          appear
          in={!this.state.shouldDisplayFullscreenFilters}
          timeout={FULLSCREEN_TRANSITION_DURATION}
          addEndListener={node => {
            node.addEventListener('transitionend', e => {
              const hidden = node.style.opacity === 0
              if (e.propertyName === 'opacity' && hidden) {
                this.setState({ shouldDisplayFullscreenFilters: true })
              }
            })
          }}
        >
          {state => {
            const contentClassName = `FilterList__content FilterList__content--${state}`

            return (
              <div className={contentClassName}>
                <div className='FilterList__contentItemsList'>
                  {this.props.filterListOptions.map((option, idx) => (
                    <div className='FilterList__contentItem' key={idx}>
                      <FilterListItem
                        {...option}
                        onSelect={() => {
                          if (option.isFullscreen) {
                            this.startFullScreenAnimation(option)
                          } else {
                            this.toggleItem(idx)
                          }
                        }}
                        onFilterSelected={this.markThatUserHasChangedFilters}
                        isExpanded={this.itemIsActive(idx)}
                      />
                    </div>
                  ))}
                </div>
                {resetButton}
              </div>
            )
          }}
        </Transition>
      )
    } else {
      fullscreenDisplay = (
        <Transition
          appear
          in={this.state.shouldDisplayFullscreenFilters}
          timeout={FULLSCREEN_TRANSITION_DURATION}
          addEndListener={node => {
            node.addEventListener('transitionend', e => {
              const isHidden = node.style.opacity === 0
              if (isHidden && e.preventDefault === 'opacity') {
                this.setState({ shouldDisplayFullscreenFilters: false })
              }
            })
          }}
        >
          {state => {
            return (
              <div
                className={`FilterList__fullscreenContentDisplay FilterList__fullscreenContentDisplay--${state}`}
              >
                <h1>
                  <i
                    className='fa fa-angle-left'
                    onClick={() => {
                      this.setState({ shouldDisplayFullscreenFilters: false })
                    }}
                  />
                  {this.state.fullscreenContentToShow
                    ? this.state.fullscreenContentToShow.label
                    : null}
                </h1>
                {this.state.fullscreenContentToShow
                  ? this.state.fullscreenContentToShow.content(
                    this.markThatUserHasChangedFilters
                  )
                  : null}
              </div>
            )
          }}
        </Transition>
      )
    }

    return (
      <FadeInFullscreen isOpen={this.props.isOpen}>
        <div className='FilterList'>
          <div
            className='FilterList__close'
            onClick={() => {
              this.props.onHide(this.state.userHasChangedFilters)
            }}
          >
            &times;
          </div>
          {filterListContent}
          {fullscreenDisplay}
        </div>
      </FadeInFullscreen>
    )
  }
}

FilterList.propTypes = {
  isOpen: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  filterListOptions: PropTypes.array.isRequired,
  filteredLabels: PropTypes.object
}

export default FilterList
